import type { RouteRecordRaw } from 'vue-router'

const sleepMonitorRoutes: RouteRecordRaw[] = [
  {
    path: 'sleep-monitor',
    name: 'sleep-monitor',
    meta: {
      titleKey: 'routes.sleep-monitor.title',
      icon: 'Monitor',
      helpKey: 'sleep_monitor'
    },
    redirect: { name: 'sleep-monitor-devices' },
    children: [
      {
        path: 'devices',
        name: 'sleep-monitor-devices',
        component: () => import('@/views/sleep-monitor/SleepMonitorDevices.vue'),
        meta: { titleKey: 'routes.sleep-monitor.devices.title', helpKey: 'sleep_monitor_devices' }
      },
      {
        path: 'bindings',
        name: 'sleep-monitor-bindings',
        component: () => import('@/views/sleep-monitor/DeviceUserBinding.vue'),
        // 🔴 `Q-060`（2026-10-21 需求方裁定「合并两个绑定入口」乙案：裁剪设计 + 合并入口）：
        // 绑定关系**唯一主入口**＝「睡眠监控 → 睡眠监控设备」页的第 2 个 Tab「睡眠监控绑定」；
        // 本独立页**移出菜单**但**保留路由**（URL `/sleep-monitor/bindings` 仍可直达，
        // 帮助 key `sleep_monitor_bindings` 与后端帮助种子保持有效）。
        // `hidden` 由 `layout/SideMenu.vue` 的菜单过滤消费（见 system.ts 的 `button-demo` 同款做法）。
        meta: { titleKey: 'routes.sleep-monitor.bindings.title', helpKey: 'sleep_monitor_bindings', hidden: true }
      },
      {
        path: 'reports',
        name: 'sleep-monitor-reports',
        component: () => import('@/views/sleep-data/SleepReportTrends.vue'),
        meta: { titleKey: 'routes.sleep-monitor.reports.title', helpKey: 'sleep_monitor_reports' }
      }
    ]
  }
]

export default sleepMonitorRoutes
